function handle_side_panel_scroll(main_panel_data, side_panel_data, baseline_data, side_panel_buttons_data) {
    var side_panel_div = side_panel_data[0];
    var side_panel_class = side_panel_data[1];
    var side_panel_buttons_div = side_panel_buttons_data[0];
    var main_panel_div = main_panel_data[0];
    var main_panel_class = main_panel_data[1];
    var baseline_bottom = baseline_data[0].outerHeight(true) + baseline_data[0].offset().top;
    var window_top = $(window).scrollTop();
    var remove_class = false;
    var add_class = false;
    var panel_top = side_panel_div.offset().top - 10; //10 is a buffer used so that it will reset when scrolling back to top

    //Logic to determin if we should add or remove class
    if (baseline_bottom >= panel_top) {
        remove_class = true;
    }
    else if (window_top >= panel_top) {
        add_class = true;
    } else {
        remove_class = true;
    }

    if (remove_class && side_panel_div.hasClass(side_panel_class)) {
        side_panel_div.removeClass(side_panel_class);
        main_panel_div.removeClass(main_panel_class);
        remove_attach_right(side_panel_buttons_div);

    } else if (add_class && !side_panel_div.hasClass(side_panel_class)) {
        side_panel_div.addClass(side_panel_class);
        main_panel_div.addClass(main_panel_class);
        attach_to_right(side_panel_div, side_panel_buttons_div, true);
    }
}

function attach_to_right(main_ele, attach_ele, animate) {
    main_ele_height = main_ele.outerHeight(true);
    attach_ele_height = attach_ele.outerHeight(true);
    if (animate) {
        attach_ele.animate({top: main_ele_height / 2 - attach_ele_height / 2}, 500);
    } else {
        attach_ele.css('top', main_ele_height / 2 - attach_ele_height / 2);
    }
}

function remove_attach_right(attach_ele) {
    attach_ele.animate({top: 0}, 500);
}


//This activates after images are loaded
$(window).on("load", function () {
    if ($(document).width() > 992) {
        var vehicle_side_panel_main_col_div = $('#vehicle-side-panel-main-col-div');
        var vehicle_panel_main_col_div = $('#vehicle-panel-main-col-div');
        var vehicle_navigation_buttons_wrapper_div = $('#vehicle-navigation-buttons-wrapper-div');
        var main_navbar = $('#main-navbar');
        if (vehicle_side_panel_main_col_div.length) {


            //Only scroll the side-panel and side-panel-buttons if the main panel is larger than side panel
            //It errors out when the side panel is larger than main panel
            if (vehicle_panel_main_col_div.outerHeight(true) + 100 > vehicle_side_panel_main_col_div.outerHeight(true)) {
                $(window).on("scroll", function () {
                    handle_side_panel_scroll(
                        [vehicle_panel_main_col_div, vehicle_panel_main_col_div.data('offset-class')],
                        [vehicle_side_panel_main_col_div, 'sticky-side-panel'],
                        [main_navbar],
                        [vehicle_navigation_buttons_wrapper_div]
                    );
                });

                //Run sticky side panel on start incase user is not at top of screen
                handle_side_panel_scroll(
                    [vehicle_panel_main_col_div, vehicle_panel_main_col_div.data('offset-class')],
                    [vehicle_side_panel_main_col_div, 'sticky-side-panel'],
                    [main_navbar],
                    [vehicle_navigation_buttons_wrapper_div]
                );
            }
        }
    }
    anchor_counter = 1;
    $('.anchor_counter').on("click", function(event){
        anchor_counter += 1;
    });

    $('#vehicle-navigation-back-button').on("click", function(event){
        var ele = $(event.target);
        history.go(-1*anchor_counter);
    });
});
